const initialState = {
	isLoading: {},
	translations: {
		pages: {},
		sections: {}
	}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case "TRANSLATIONS_IS_LOADING":
			// console.log(action.key, action.combinedIndexes);

			// Get copy of initial state, pages and sections seperately
			let pages = { ...state.translations.pages };
			let sections = { ...state.translations.sections };

			// Reset pages requested
			for (let i = 0; i < action.combinedIndexes.pages.length; i++) {
				// If the page exists in the initial state, we will continue
				if (!!pages[action.combinedIndexes.pages[i]]) {
					// Remove the unwanted page being loaded using destructuring
					let { [action.combinedIndexes.pages[i]]: val, ...newTrans } = pages;

					// Copy the pages object, now without the removed page
					pages = { ...newTrans };
				}
			}

			// Reset sections requested (same as above)
			for (let i = 0; i < action.combinedIndexes.sections.length; i++) {
				if (!!sections[action.combinedIndexes.sections[i]]) {
					let { [action.combinedIndexes.sections[i]]: val, ...newTrans } = sections;
					sections = { ...newTrans };
				}
			}

			// console.log("translations after reset pages:", pages);
			// console.log("translations after reset sections:", sections);

			return {
				...state,
				isLoading: {
					...state.isLoading,
					[action.key]: 1
				},
				error: null,
				translations: {
					pages,
					sections
				}
			};
		case "TRANSLATIONS_HAS_ERROR":
			return {
				...state,
				isLoading: {
					...state.isLoading,
					[action.key]: 0
				},
				error: action.err
			};
		case "TRANSLATIONS_SUCCESS":
			return {
				...state,
				isLoading: {
					...state.isLoading,
					[action.key]: 0
				},
				translations: {
					pages: {
						...state.translations.pages,
						...action.translations.pages
					},
					sections: {
						...state.translations.sections,
						...action.translations.sections
					}
				}
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/translations.js